module.exports = __webpack_public_path__ + "static/Chic_&_Unique_372X480.5ac035f4.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/Chic_&_Unique_372X480.png
// module id = 52
// module chunks = 35783957827783 174759553322802 227638899823042